.progressBar {
  transition: all 550ms ease-in-out;
}
